export default [
  {
    title: 'Dashboard',
    acl: ['*'],
    to: { name: 'dashboard' },
    icon: { icon: 'tabler-dashboard' },
  },
  {
    title: 'View Orders',
    acl: ['Admin', 'Billing', 'Manager'],
    to: { name: 'business-orders' },
    icon: { icon: 'tabler-reorder' },
  },
  {
    title: 'Reports',
    acl: ['Admin', 'Billing', 'Manager'],
    to: { name: 'business-orders-reports' },
    icon: { icon: 'tabler-chart-dots' },
  },
  {
    heading: 'Manage',
    acl: ['Admin', 'Billing', 'Editor'],
  },
  {
    title: 'Businesses',
    acl: ['Admin'],
    to: { name: 'business' },
    icon: { icon: 'tabler-smart-home' },
  },
  {
    title: 'Floor plans',
    acl: ['Admin'],
    to: { name: 'business-floorplan' },
    icon: { icon: 'tabler-building-castle' },
    // Wave D: tables/floor plans are hospitality furniture — hidden when every
    // business the user can see is retail (layout filters on this tag).
    experience: 'hospitality',
  },
  {
    title: 'Inventory',
    acl: ['Admin', 'Manager'],
    to: { name: 'business-inventory' },
    icon: { icon: 'tabler-packages' },
  },
  {
    title: 'Pricing & Billing',
    acl: ['Admin'],
    icon: { icon: 'tabler-credit-card' },
    children: [
      {
        title: 'Plans',
        to: { name: 'business-pricing' },
      },
      {
        title: 'Payment Methods',
        to: { name: 'business-payment-methods' },
      },
      {
        title: 'Statements',
        to: { name: 'business-billing-statements' },
      },
    ],
  },

  {
    heading: 'Staff management',
    acl: ['Admin'],
  },
  {
    title: 'Staff',
    icon: { icon: 'tabler-users-group' },
    acl: ['Admin'],
    children: [
      {
        title: 'Manage Staff',
        acl: ['Admin', 'Billing'],
        to: { name: 'business-manager-staff' },
        icon: { icon: 'tabler-users-group' },
      },
      {
        title: 'Roster',
        acl: ['Admin', 'Billing'],
        to: { name: 'business-manager-roster' },
        icon: { icon: 'tabler-calendar-clock' },
      },
      {
        title: 'Staff Hours Report',
        acl: ['Admin', 'Billing'],
        to: { name: 'business-manager-staff-hours-report' },
        icon: { icon: 'tabler-clock-hour-4' },
      },
    ],
  },
  {
    heading: 'Menus',
    acl: ['Admin', 'Editor'],
  },
  {
    title: 'Manage menus',
    icon: { icon: 'tabler-menu-2' },
    acl: ['Admin', 'Editor'],
    to: { name: 'business-menu-list' },
  },
  {
    title: 'Alerts',
    icon: { icon: 'tabler-alert-triangle' },
    acl: ['Admin', 'Editor'],
    to: { name: 'business-menu-alerts' },
  },
  {
    heading: 'CRM & Marketing',
    acl: ['Admin'],
  },
  {
    title: 'CRM Dashboard',
    acl: ['Admin'],
    to: { name: 'business-crm' },
    icon: { icon: 'mdi mdi-account-heart' },
  },
  {
    title: 'Campaigns',
    acl: ['Admin'],
    to: { name: 'business-crm-campaigns' },
    icon: { icon: 'mdi mdi-email-newsletter' },
  },
  {
    title: 'Email Templates',
    acl: ['Admin'],
    to: { name: 'business-crm-templates' },
    icon: { icon: 'mdi mdi-file-document-edit' },
  },
  {
    title: 'Customers',
    acl: ['Admin'],
    to: { name: 'business-crm-customers' },
    icon: { icon: 'mdi mdi-account-search' },
  },
  {
    title: 'Loyalty Program',
    acl: ['Admin'],
    to: { name: 'business-crm-loyalty' },
    icon: { icon: 'mdi mdi-gift' },
  },

  {
    heading: 'Deals management',
    acl: ['Admin'],
  },
  {
    title: 'Deals',
    acl: ['Admin'],
    to: { name: 'business-deals' },
    icon: { icon: 'tabler-pencil-discount' },
  },
  {
    title: 'Vouchers',
    acl: ['Admin'],
    to: { name: 'business-voucher' },
    icon: { icon: 'tabler-certificate' },
  },
  {
    title: 'Import/Export',
    icon: { icon: 'tabler-refresh' },
    acl: ['Admin'],
    children: [
      {
        title: 'Import data',
        acl: ['Admin'],
        to: { name: 'business-import' },
        icon: { icon: 'tabler-arrow-down' },
      },
      {
        title: 'Export data',
        acl: ['Admin', 'Editor'],
        to: { name: 'business-export' },
        icon: { icon: 'tabler-arrow-right' },
      },
    ],
  },
  {
    heading: 'Support',
    acl: ['*'],
  },
  {
    title: 'Help & Documentation',
    acl: ['*'],
    to: { name: 'help' },
    icon: { icon: 'tabler-help-circle' },
  },

  /*{
                                                heading: 'Marketing',
                                                acl: ['Admin'],
                                              },
                                              {
                                                title: 'Settings',
                                                acl: ['Admin'],
                                                to: { name: 'business-marketing' },
                                                icon: { icon: 'tabler-report-analytics' },
                                              },
                                              {
                                                title: 'Reports',
                                                acl: ['Admin'],
                                                to: { name: 'business-marketing-reports' },
                                                icon: { icon: 't-checkup-list' },
                                              },
  
                                                {
                                                    heading: 'Configure',
                                                    acl: ['Admin'],
                                                  },
                                                  {
                                                    title: 'QR System',
                                                    acl: ['Admin'],
                                                    to: { name: 'business-configure-qr' },
                                                    icon: { icon: 'tabler-qrcode' },
                                                  },
                                                  {
                                                    title: 'POS system',
                                                    acl: ['Admin'],
                                                    to: { name: 'business-configure-pos' },
                                                    icon: { icon: 'tabler-devices-pc' },
                                                  },
                                                  {
                                                    title: 'Order tablets',
                                                    acl: ['Admin'],
                                                    to: { name: 'business-configure-order-tablets' },
                                                    icon: { icon: 'tabler-device-tablet-dollar' },
                                                  },
                                                  {
                                                    title: 'KIOSK',
                                                    acl: ['Admin'],
                                                    to: { name: 'business-configure-kiosk' },
                                                    icon: { icon: 'tabler-user-screen' },
                                                  },
                                                  {
                                                    title: 'Driver tracker',
                                                    acl: ['Admin'],
                                                    to: { name: 'business-configure-trackers' },
                                                    icon: { icon: 'tabler-gps' },
                                                  },*/
]
